import { TeamListLayout } from "../types/TeamListLayout";

const TeamList = ({ title }: TeamListLayout) => {
  return <div>team list {title}</div>;
};

export default TeamList;
